import { Action } from '@ngrx/store';

import { Locale } from '../../shared/models/locale.model';
import { type } from '../../util';

export const actionTypes = {
  SET_LOCALE: type('[Locale] Set the application Locale'),
};

export class SetLocale implements Action {
  type = actionTypes.SET_LOCALE;

  constructor(public payload: Locale) { }
}

export type Actions
  = SetLocale;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/locale/locale.actions.ts